import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: any;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  data: {
    ids: [],
    month: moment().month() + 1,
    year: moment().year(),
  },
};

const confirmTimeKeepingSlice = createSlice({
  name: "confirmTimeKeeping",
  initialState,
  reducers: {
    setDataConfirmTimeKeeping: (state, action) => {
      Object.assign(state.data, action.payload);
    },
    confirmTimeKeepingStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    confirmTimeKeepingSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
    },
    confirmTimeKeepingFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetDataConfirmTimeKeeping: () => {
      return { ...initialState };
    },
  },
});

export const {
  setDataConfirmTimeKeeping,
  confirmTimeKeepingStart,
  confirmTimeKeepingSuccess,
  confirmTimeKeepingFailed,
  resetDataConfirmTimeKeeping,
} = confirmTimeKeepingSlice.actions;

export default confirmTimeKeepingSlice.reducer;
